module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/BelowDeckMed_S4.98ce28a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/BelowDeckMed_S4.jpg
// module id = q+Av
// module chunks = 0